/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Cancel_ButtonInputs */

const en_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_manual_qc_cancel_button = /** @type {(inputs: Manual_Qc_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Manual_Qc_Cancel_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_cancel_button = /** @type {((inputs?: Manual_Qc_Cancel_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Cancel_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_cancel_button(inputs)
	if (locale === "de") return de_manual_qc_cancel_button(inputs)
	if (locale === "it") return it_manual_qc_cancel_button(inputs)
	if (locale === "ru") return ru_manual_qc_cancel_button(inputs)
	if (locale === "es") return es_manual_qc_cancel_button(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_cancel_button(inputs)
	if (locale === "ja") return ja_manual_qc_cancel_button(inputs)
	if (locale === "hi") return hi_manual_qc_cancel_button(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_cancel_button(inputs)
	return en_manual_qc_cancel_button(inputs)
});